// Modal.js
import React from 'react'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import { Close } from "@mui/icons-material"
import IconButton from '@mui/material/IconButton'

const style = {
    backgroundColor: 'rgb(255, 255, 255)',
    color: 'rgb(38, 38, 38)',
    position: 'absolute',
    boxShadow: 'inherit',
    padding: { xs: 2, sm: 3 },
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    width: { xs: 'calc(100vw - 32px)', sm: 'auto' },
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: 'calc(100dvh - 32px)',
    overflow: 'auto',
    outline: 'none',
    borderRadius: '4px',
    borderColor: 'rgb(230, 235, 241)',
    "&div": {
        borderRadius: '4px',
    }
}

const CustomModal = ({ open, handleClose, children }) => {
    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        float: 'right',
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
                {children}
            </Box>
        </Modal>
    )
}

export default CustomModal
